import React from 'react';
import EditorLayout from '../../../../components/Layouts/EditorLayout';
import SMCTextInput from '../../../../components/Simple/SMCTextInput';
import {CommunityGetSchema} from '../../../../api/DBSchema/Community';

function CommunityCustomFields({
    communityObject,
    setCommunityData
}) {
    const customFieldOne = communityObject[CommunityGetSchema.customFieldOne];
    const customFieldTwo = communityObject[CommunityGetSchema.customFieldTwo];
    
    const customFieldSchema = CommunityGetSchema.customFieldSchema;

    return (
        <EditorLayout>
            {
                customFieldOne && (
                    <SMCTextInput
                        value={customFieldOne[customFieldSchema.value]}
                        onChange={e => setCommunityData([CommunityGetSchema.customFieldOne, customFieldSchema.value], e.target.value)}
                        label={customFieldOne[customFieldSchema.name]}
                    />
                )
            }
            {
                customFieldTwo && (
                    <SMCTextInput
                        value={customFieldTwo[customFieldSchema.value]}
                        onChange={e => setCommunityData([CommunityGetSchema.customFieldTwo, customFieldSchema.value], e.target.value)}
                        label={customFieldTwo[customFieldSchema.name]}
                    />
                )
            }
        </EditorLayout>
    )
}

export default CommunityCustomFields;